// extracted by mini-css-extract-plugin
export default {"section-sticky-header":"SectionStickyHeader_section-sticky-header__lD3jH","title-prefix":"SectionStickyHeader_title-prefix__fUi+P","title":"SectionStickyHeader_title__PGqra"};